import axios from '@axios'

export default {
  state: {
    // subscriptionsOrgId: null,
    subscriptionsData: null,
    employeeSubscriptionData: null,
    appSubscriptionData: null,
    purchasesData: null,
  },
  getters: {
    // getSubscriptionsOrgId(state) {
    //   return state.subscriptionsOrgId
    // },
    getSubscriptionsData(state) {
      return state.subscriptionsData
    },
    getPurchasesData(state) {
      return state.purchasesData
    },
    getEmployeeSubscriptionData(state) {
      return state.employeeSubscriptionData
    },
    getAppSubscriptionData(state) {
      return state.appSubscriptionData
    },
  },
  mutations: {
    UPDATE_SUBSCRIPTIONS_DATA(state, data) {
      try {

        const subscriptions = data.stripe_platform.subscriptions

        // Проверяем, что передан объект и у него есть массив existing_subscriptions
        if (!subscriptions || typeof subscriptions !== 'object' || !Array.isArray(subscriptions.existing_subscriptions)) {
          console.error("Invalid data format: expected an object with 'existing_subscriptions' array", data)
          return;
        }

        if (subscriptions.existing_subscriptions.length) {
          // Проходим по существующим подпискам
          for (const sub of subscriptions.existing_subscriptions) {
            if (sub.product_type === 'public_workspace') {
              state.employeeSubscriptionData = sub
            } else if (sub.product_type === 'mobile_app_access') {
              state.appSubscriptionData = sub
            }
          }
        } else {
          state.employeeSubscriptionData = null
          state.appSubscriptionData = null
        }

        // Сохраняем подписки в state
        state.subscriptionsData = data.stripe_platform.subscriptions
        // Сохраняем продукты в state
        state.purchasesData = data.stripe_platform.purchases
      } catch (error) {
        console.error("UPDATE_SUBSCRIPTIONS_DATA error:", error)
      }
    },
    // UPDATE_PURCHASES_DATA(state, data) {
    //
    // },
  },
  actions: {
    goToCustomerPortal(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/payments/stripe/platform/subscriptions/portal/`, data)
          .then(response => {
            // context.commit('updateCurrency', response.data.currency)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    goToCheckoutSubscription(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/payments/stripe/platform/subscriptions/checkout/', data)
          .then(response => {
            // context.commit('updateCurrency', response.data.currency)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    goToCheckoutPurchases(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('/payments/stripe/platform/purchases/checkout/', data)
          .then(response => {
            // context.commit('updateCurrency', response.data.currency)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
